import type { SVGProps } from "react";

// ==========================================
// 1. 云流加速器品牌主 Logo（云流极光盾形矢量标）
// ==========================================
export function YunliuLogoIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={32}
      height={32}
      {...props}
    >
      <defs>
        <linearGradient id="yl-grad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#ff9a61" />
          <stop offset="50%" stopColor="#ff7a35" />
          <stop offset="100%" stopColor="#d94d16" />
        </linearGradient>
        <filter id="yl-glow" x="-20%" y="-20%" width="140%" height="140%">
          <feDropShadow dx="0" dy="2" stdDeviation="2.5" floodColor="#ff6b2b" floodOpacity="0.38" />
        </filter>
      </defs>
      {/* 外圈微晶盾形 */}
      <rect
        x="3"
        y="3"
        width="34"
        height="34"
        rx="10"
        fill="url(#yl-grad)"
        filter="url(#yl-glow)"
      />
      {/* 内部极速云流线条与前行动力剪影 */}
      <path
        d="M13 22c-1.66 0-3-1.34-3-3 0-1.54 1.16-2.8 2.65-2.97C13.2 12.63 16.27 10 20 10c3.15 0 5.86 1.83 6.94 4.5 1.7-.1 3.2 1.05 3.5 2.73.9.5 1.56 1.48 1.56 2.61 0 1.74-1.38 3.16-3.1 3.16H13z"
        fill="#ffffff"
        opacity="0.95"
      />
      <path
        d="M14 26.5h12M17 30h6"
        stroke="#ffffff"
        strokeWidth="2.5"
        strokeLinecap="round"
      />
      <path
        d="M26 23l4 3.5-4 3.5"
        stroke="#ffffff"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

// ==========================================
// 2. Bento 核心优势质感徽标 (4款，48x48)
// ==========================================

// 01 高清视频：4K 超高清视界大屏与立体光束
export function BenefitVideoIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={48}
      height={48}
      {...props}
    >
      <defs>
        <linearGradient id="bv-bg" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#3b82f6" />
          <stop offset="100%" stopColor="#1d4ed8" />
        </linearGradient>
        <linearGradient id="bv-gold" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#fbbf24" />
          <stop offset="100%" stopColor="#d97706" />
        </linearGradient>
        <filter id="bv-shadow" x="-20%" y="-20%" width="140%" height="140%">
          <feDropShadow dx="0" dy="4" stdDeviation="4" floodColor="#1d4ed8" floodOpacity="0.35" />
        </filter>
      </defs>
      {/* 蓝晶底座 */}
      <rect x="4" y="4" width="40" height="40" rx="12" fill="url(#bv-bg)" filter="url(#bv-shadow)" />
      {/* 4K 极窄边框电视屏幕 */}
      <rect x="9" y="10" width="30" height="21" rx="4" fill="#0f172a" stroke="#60a5fa" strokeWidth="1.5" />
      {/* 屏幕内金色播放透镜 */}
      <path d="M21 16.5a1 1 0 011.53-.85l6.5 4.2a1 1 0 010 1.7l-6.5 4.2a1 1 0 01-1.53-.85v-8.4z" fill="url(#bv-gold)" />
      {/* 屏幕高光折角 */}
      <path d="M10 11l14 14" stroke="#ffffff" strokeWidth="1.5" strokeLinecap="round" opacity="0.3" />
      {/* 底座支架与 4K 标志点 */}
      <path d="M20 31h8M24 31v4M18 35h12" stroke="#93c5fd" strokeWidth="2" strokeLinecap="round" />
      <circle cx="34" cy="14" r="1.5" fill="#38bdf8" />
    </svg>
  );
}

// 02 音乐畅听：Hi-Fi 录音室金圈耳机与动感律动波形
export function BenefitMusicIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={48}
      height={48}
      {...props}
    >
      <defs>
        <linearGradient id="bm-bg" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#8b5cf6" />
          <stop offset="100%" stopColor="#6d28d9" />
        </linearGradient>
        <linearGradient id="bm-gold" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#fde047" />
          <stop offset="100%" stopColor="#ca8a04" />
        </linearGradient>
        <filter id="bm-shadow" x="-20%" y="-20%" width="140%" height="140%">
          <feDropShadow dx="0" dy="4" stdDeviation="4" floodColor="#6d28d9" floodOpacity="0.35" />
        </filter>
      </defs>
      {/* 紫水晶底座 */}
      <rect x="4" y="4" width="40" height="40" rx="12" fill="url(#bm-bg)" filter="url(#bm-shadow)" />
      {/* 耳机弓梁 */}
      <path
        d="M13 24v-4a11 11 0 0122 0v4"
        stroke="#ffffff"
        strokeWidth="3.2"
        strokeLinecap="round"
      />
      {/* 两侧金色耳罩 */}
      <rect x="10" y="21" width="5.5" height="11" rx="2.75" fill="url(#bm-gold)" stroke="#ffffff" strokeWidth="1" />
      <rect x="32.5" y="21" width="5.5" height="11" rx="2.75" fill="url(#bm-gold)" stroke="#ffffff" strokeWidth="1" />
      {/* 中间动态音浪波形 */}
      <path d="M19 28v-3M22 30v-7M24 32v-11M26 30v-7M29 28v-3" stroke="#a7f3d0" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}

// 03 游戏加速：次世代涡轮电竞手柄与极速电光
export function BenefitGameIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={48}
      height={48}
      {...props}
    >
      <defs>
        <linearGradient id="bg-bg" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#06b6d4" />
          <stop offset="100%" stopColor="#0891b2" />
        </linearGradient>
        <filter id="bg-shadow" x="-20%" y="-20%" width="140%" height="140%">
          <feDropShadow dx="0" dy="4" stdDeviation="4" floodColor="#0891b2" floodOpacity="0.35" />
        </filter>
      </defs>
      {/* 极光青底座 */}
      <rect x="4" y="4" width="40" height="40" rx="12" fill="url(#bg-bg)" filter="url(#bg-shadow)" />
      {/* 手柄机身 */}
      <path
        d="M15 17h18c3 0 5.5 2 6 5l2 8.5c.5 2.5-1.5 4.8-4.1 4.5-1.8-.2-3.3-1.5-4-3.2l-1.3-3.8c-.4-1.2-1.6-2-2.8-2h-9.6c-1.2 0-2.4.8-2.8 2l-1.3 3.8c-.7 1.7-2.2 3-4 3.2-2.6.3-4.6-2-4.1-4.5l2-8.5c.5-3 3-5 6-5z"
        fill="#ffffff"
      />
      {/* 十字键 */}
      <rect x="16.5" y="21" width="2" height="5" rx="1" fill="#0891b2" />
      <rect x="15" y="22.5" width="5" height="2" rx="1" fill="#0891b2" />
      {/* 4颗彩色电竞按键 */}
      <circle cx="31" cy="21.5" r="1.2" fill="#ef4444" />
      <circle cx="28.5" cy="23.5" r="1.2" fill="#3b82f6" />
      <circle cx="33.5" cy="23.5" r="1.2" fill="#eab308" />
      <circle cx="31" cy="25.5" r="1.2" fill="#10b981" />
      {/* 极速闪电灯条 */}
      <path d="M21 19.5h6" stroke="#06b6d4" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  );
}

// 04 智能分流：量子路由分流枢纽与双色光纤通道
export function BenefitRoutingIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={48}
      height={48}
      {...props}
    >
      <defs>
        <linearGradient id="br-bg" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#10b981" />
          <stop offset="100%" stopColor="#047857" />
        </linearGradient>
        <filter id="br-shadow" x="-20%" y="-20%" width="140%" height="140%">
          <feDropShadow dx="0" dy="4" stdDeviation="4" floodColor="#047857" floodOpacity="0.35" />
        </filter>
      </defs>
      {/* 翡翠绿底座 */}
      <rect x="4" y="4" width="40" height="40" rx="12" fill="url(#br-bg)" filter="url(#br-shadow)" />
      {/* 核心分流芯片节点 */}
      <circle cx="24" cy="15" r="4.5" fill="#ffffff" />
      <circle cx="24" cy="15" r="2" fill="#047857" />
      {/* 左侧通道（国内专线-蓝光） */}
      <path
        d="M24 19.5v5c0 2-1 3-3 4l-4 3"
        stroke="#ffffff"
        strokeWidth="2.5"
        strokeLinecap="round"
      />
      <circle cx="15" cy="33" r="4" fill="#38bdf8" />
      <circle cx="15" cy="33" r="1.8" fill="#ffffff" />
      {/* 右侧通道（海外直连-金光） */}
      <path
        d="M24 19.5v5c0 2 1 3 3 4l4 3"
        stroke="#ffffff"
        strokeWidth="2.5"
        strokeLinecap="round"
      />
      <circle cx="33" cy="33" r="4" fill="#fde047" />
      <circle cx="33" cy="33" r="1.8" fill="#ffffff" />
    </svg>
  );
}

// ==========================================
// 3. 多端平台官方质感徽标 (4款，44x44)
// ==========================================

// Windows: Windows 11 Fluent 经典四格蓝调矢量徽标
export function WindowsIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 44 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={40}
      height={40}
      {...props}
    >
      <defs>
        <linearGradient id="win-lt" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#00adef" />
          <stop offset="100%" stopColor="#0078d4" />
        </linearGradient>
        <linearGradient id="win-rb" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#0078d4" />
          <stop offset="100%" stopColor="#005a9e" />
        </linearGradient>
        <filter id="win-glow" x="-20%" y="-20%" width="140%" height="140%">
          <feDropShadow dx="0" dy="2" stdDeviation="2.5" floodColor="#0078d4" floodOpacity="0.3" />
        </filter>
      </defs>
      <rect x="2" y="2" width="40" height="40" rx="10" fill="#f0f9ff" stroke="#bae6fd" strokeWidth="1" />
      {/* 四格微倾 Fluent 瓦片 */}
      <rect x="9" y="9" width="11.5" height="11.5" rx="1.5" fill="url(#win-lt)" filter="url(#win-glow)" />
      <rect x="23.5" y="9" width="11.5" height="11.5" rx="1.5" fill="url(#win-lt)" filter="url(#win-glow)" />
      <rect x="9" y="23.5" width="11.5" height="11.5" rx="1.5" fill="url(#win-rb)" filter="url(#win-glow)" />
      <rect x="23.5" y="23.5" width="11.5" height="11.5" rx="1.5" fill="url(#win-rb)" filter="url(#win-glow)" />
    </svg>
  );
}

// macOS: 苹果金属微质感拟态 Apple 矢量徽标
export function MacosIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 44 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={40}
      height={40}
      {...props}
    >
      <defs>
        <linearGradient id="mac-apple" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#475569" />
          <stop offset="100%" stopColor="#1e293b" />
        </linearGradient>
        <filter id="mac-shadow" x="-20%" y="-20%" width="140%" height="140%">
          <feDropShadow dx="0" dy="2" stdDeviation="2" floodColor="#0f172a" floodOpacity="0.25" />
        </filter>
      </defs>
      <rect x="2" y="2" width="40" height="40" rx="10" fill="#f8fafc" stroke="#e2e8f0" strokeWidth="1" />
      {/* 顶部苹果叶 */}
      <path
        d="M24.2 11c.8-1 1.4-2.4 1.2-3.8-1.2.1-2.6.8-3.4 1.8-.7.8-1.4 2.2-1.2 3.6 1.3.1 2.6-.6 3.4-1.6z"
        fill="url(#mac-apple)"
      />
      {/* 苹果机身 */}
      <path
        d="M25.3 15.8c-1.3 0-2.4.8-3.1.8-.7 0-1.7-.7-2.8-.7-1.4 0-2.8.8-3.5 2.1-1.5 2.6-.4 6.5 1.1 8.6.7 1.1 1.6 2.2 2.7 2.2 1.1 0 1.5-.7 2.8-.7s1.7.7 2.8.7c1.2 0 1.9-1 2.7-2.1.8-1.2 1.2-2.4 1.2-2.5 0-.1-2.3-.9-2.3-3.6 0-2.2 1.8-3.3 1.9-3.4-1-1.5-2.6-1.4-3.5-1.4z"
        fill="url(#mac-apple)"
        filter="url(#mac-shadow)"
      />
    </svg>
  );
}

// iOS: 苹果移动生态炫彩灵动岛徽标
export function IosIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 44 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={40}
      height={40}
      {...props}
    >
      <defs>
        <linearGradient id="ios-bg" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#3b82f6" />
          <stop offset="100%" stopColor="#1d4ed8" />
        </linearGradient>
        <filter id="ios-shadow" x="-20%" y="-20%" width="140%" height="140%">
          <feDropShadow dx="0" dy="2.5" stdDeviation="2.5" floodColor="#2563eb" floodOpacity="0.3" />
        </filter>
      </defs>
      <rect x="2" y="2" width="40" height="40" rx="10" fill="#eff6ff" stroke="#dbeafe" strokeWidth="1" />
      {/* 手机外框 */}
      <rect
        x="13.5"
        y="7"
        width="17"
        height="30"
        rx="4.5"
        fill="url(#ios-bg)"
        filter="url(#ios-shadow)"
      />
      {/* 屏幕灵动岛与屏幕高光 */}
      <rect x="18.5" y="9" width="7" height="2" rx="1" fill="#0f172a" />
      <rect x="15" y="13" width="14" height="20.5" rx="2" fill="#ffffff" opacity="0.95" />
      {/* 底部小横条 */}
      <rect x="18" y="31" width="8" height="1.2" rx="0.6" fill="#64748b" />
    </svg>
  );
}

// Android: 谷歌原生 3D 薄荷绿 Bugdroid 机器人头雕徽标
export function AndroidIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 44 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={40}
      height={40}
      {...props}
    >
      <defs>
        <linearGradient id="and-green" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#3ddc84" />
          <stop offset="100%" stopColor="#10b981" />
        </linearGradient>
        <filter id="and-shadow" x="-20%" y="-20%" width="140%" height="140%">
          <feDropShadow dx="0" dy="2.5" stdDeviation="2.5" floodColor="#10b981" floodOpacity="0.35" />
        </filter>
      </defs>
      <rect x="2" y="2" width="40" height="40" rx="10" fill="#f0fdf4" stroke="#dcfce7" strokeWidth="1" />
      {/* 机器人头部天线 */}
      <path d="M15 15l-2.5-4.5M29 15l2.5-4.5" stroke="#3ddc84" strokeWidth="2.2" strokeLinecap="round" />
      {/* 机器人半球头雕 */}
      <path
        d="M13 25c0-6.07 4.93-11 11-11s11 4.93 11 11H13z"
        fill="url(#and-green)"
        filter="url(#and-shadow)"
      />
      {/* 机器双眼 */}
      <circle cx="18" cy="20" r="1.5" fill="#ffffff" />
      <circle cx="26" cy="20" r="1.5" fill="#ffffff" />
    </svg>
  );
}

// ==========================================
// 4. 快速开始 3 步插画图元 (3款，40x40)
// ==========================================

// 步骤 01：下载客户端
export function StepDownloadIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={36}
      height={36}
      {...props}
    >
      <defs>
        <linearGradient id="sd-bg" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#3b82f6" />
          <stop offset="100%" stopColor="#2563eb" />
        </linearGradient>
      </defs>
      <rect x="2" y="2" width="36" height="36" rx="9" fill="#eff6ff" stroke="#bfdbfe" strokeWidth="1" />
      <path
        d="M20 10v13M14 17l6 6 6-6"
        stroke="url(#sd-bg)"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11 26h18v2a2 2 0 01-2 2H13a2 2 0 01-2-2v-2z"
        fill="url(#sd-bg)"
      />
      <circle cx="20" cy="28" r="1" fill="#ffffff" />
    </svg>
  );
}

// 步骤 02：选择应用场景
export function StepAppSelectIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={36}
      height={36}
      {...props}
    >
      <defs>
        <linearGradient id="sa-bg" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#8b5cf6" />
          <stop offset="100%" stopColor="#7c3aed" />
        </linearGradient>
      </defs>
      <rect x="2" y="2" width="36" height="36" rx="9" fill="#f5f3ff" stroke="#ddd6fe" strokeWidth="1" />
      {/* 四格应用选择微盘 */}
      <rect x="10" y="10" width="8" height="8" rx="2" fill="url(#sa-bg)" />
      <rect x="22" y="10" width="8" height="8" rx="2" fill="#c4b5fd" />
      <rect x="10" y="22" width="8" height="8" rx="2" fill="#c4b5fd" />
      <rect x="22" y="22" width="8" height="8" rx="2" fill="url(#sa-bg)" />
      {/* 核心被激活的小对勾 */}
      <path d="M12.5 14l1.5 1.5 3-3" stroke="#ffffff" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

// 步骤 03：一键加速（超音速火箭）
export function StepRocketIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={36}
      height={36}
      {...props}
    >
      <defs>
        <linearGradient id="sr-rocket" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#06b6d4" />
          <stop offset="100%" stopColor="#0284c7" />
        </linearGradient>
        <linearGradient id="sr-fire" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#f59e0b" />
          <stop offset="100%" stopColor="#ef4444" />
        </linearGradient>
      </defs>
      <rect x="2" y="2" width="36" height="36" rx="9" fill="#ecfeff" stroke="#a5f3fc" strokeWidth="1" />
      {/* 倾斜火箭舱身 */}
      <path
        d="M27.5 8.5c-4.5 1.5-8 5.5-9.5 10l-2.5.5-2 3.5 3 1.5-.5 3 3-.5 1.5 3 3.5-2 .5-2.5c4.5-1.5 8.5-5 10-9.5-2-4.5-5-6-7-7z"
        fill="url(#sr-rocket)"
      />
      {/* 火箭舷窗 */}
      <circle cx="24" cy="14" r="2" fill="#ffffff" />
      {/* 尾焰 */}
      <path
        d="M13 27l-3 3c-.5.5-.5 1.5 0 2s1.5.5 2 0l3-3-2-2z"
        fill="url(#sr-fire)"
      />
    </svg>
  );
}
